import { NgModule, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { NgStyle } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { Widget } from './widget.component';
import { WidgetDirective } from './widget.directive';
import { HomePage } from '../pages/home/home';
import { MessageService } from './message.service';
import { EditTextPage } from '../pages/edit-text/edit-text';
import { CredentialsService } from './credentials.service';
import { DatastoreService } from './datastore.service';
import { HubService } from './hub.service';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { IonicStorageModule } from '@ionic/storage';

export class RouterStub {
  navigateByUrl(url: string) {
    return url;
  }
}

@NgModule({
  declarations: [
    MyApp,
    WidgetDirective,
    HomePage,
    EditTextPage,
    Widget,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicStorageModule.forRoot({
      name: '__mydb',
         driverOrder: ['sqlite', 'websql', 'indexeddb']
    }),
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    EditTextPage,
    Widget,
  ],
  providers: [
    {provide: Router, useClass: RouterStub},
    StatusBar,
    SplashScreen,
    MessageService,
    CredentialsService,
    DatastoreService,
    HubService,
    NgStyle,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts